import * as React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import styled from 'styled-components';
import { SettingsItemContentProps } from '../SettingsItem';
import Users from '../../Users';
import { useEntities } from '../../../store/entities/hooks';
import { UserEntity } from '../../../store/entities/state';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import OrgChart from './OrgChart';
import AppButton from '../../../components/AppButton';

const OrgChartHeader = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-bottom: var(--spacer-S);
`;

const UsersSettings: React.FC<SettingsItemContentProps> = () => {
    const t = useTranslations();
    const users = useEntities<UserEntity>('users');
    const [showOrgChart, setShowOrgChart] = React.useState(false);

    const hasManagerRelationships = users.some(u => u.managerId && users.some(m => m.id === u.managerId));

    return (
        <>
            <Users />
            {hasManagerRelationships && (
                <OrgChartHeader>
                    <AppButton color="link" onClick={() => setShowOrgChart(true)}>
                        {t(TK.showOrgChart)}
                    </AppButton>
                </OrgChartHeader>
            )}
            <Modal isOpen={showOrgChart} toggle={() => setShowOrgChart(false)} size="lg">
                <ModalHeader toggle={() => setShowOrgChart(false)}>
                    {t(TK.orgChart)}
                </ModalHeader>
                <ModalBody>
                    <OrgChart users={users} onClose={() => setShowOrgChart(false)} />
                </ModalBody>
            </Modal>
        </>
    );
};

export default UsersSettings;
